var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({staticClass:"growup",attrs:{"auto-grow":""}},'v-textarea',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }